import { useState } from "react";
import { PaymentModal, PAYPAL_OPTIONS } from "@/components/PaymentModal";

export { PAYPAL_OPTIONS };

export const PayPalBuy = ({ product, credits, onSuccess }) => {
  const [open, setOpen] = useState(false);
  const label = product === "pro" ? "Buy PRO — $10" : `Buy $${(credits * 0.05).toFixed(2)}`;
  return (
    <>
      <button
        data-testid={`pay-btn-${product}`}
        onClick={() => setOpen(true)}
        className="w-full py-2.5 text-sm font-bold bg-[#C0392B] text-white rounded-full hover:bg-[#A93226] transition-colors"
      >
        {label}
      </button>
      <PaymentModal open={open} onOpenChange={setOpen} product={product} credits={credits} onSuccess={onSuccess} />
    </>
  );
};
